import 'typeface-lato'
import './src/styles/global.css'
